(function () {
  /** Contenedores donde no convertir div/p “título numerado” en h3. */
  function skipLegacyHeadingWrapper(el) {
    return (
      !el ||
      el.closest('.ecoway-accordion') ||
      el.closest('.card-grid') ||
      el.closest('.ecoway-no-accordion') ||
      el.closest('a.card-item')
    );
  }

  /** Texto tipo "1) Título de sección" pegado desde Word / editores ricos. */
  function looksLikeNumberedSectionTitle(text) {
    var t = text.replace(/\s+/g, ' ').trim();
    return /^\d+\)/.test(t) && t.length >= 8;
  }

  /** Convierte <div><b>1) …</b></div> o <p><strong>1) …</strong></p> en <h3> reales. */
  function normalizeNumberedPseudoHeadings(rte) {
    Array.from(rte.querySelectorAll('div')).forEach(function (div) {
      if (skipLegacyHeadingWrapper(div)) return;
      if (div.children.length !== 1) return;
      var only = div.children[0];
      if (only.tagName !== 'B' && only.tagName !== 'STRONG') return;
      var t = div.textContent || '';
      if (!looksLikeNumberedSectionTitle(t)) return;
      var h3 = document.createElement('h3');
      h3.textContent = t.replace(/\s+/g, ' ').trim();
      div.parentNode.replaceChild(h3, div);
    });

    Array.from(rte.querySelectorAll('p')).forEach(function (p) {
      if (skipLegacyHeadingWrapper(p)) return;
      if (p.children.length !== 1) return;
      var only = p.children[0];
      if (only.tagName !== 'B' && only.tagName !== 'STRONG') return;
      var t = p.textContent || '';
      if (!looksLikeNumberedSectionTitle(t)) return;
      var h3 = document.createElement('h3');
      h3.textContent = t.replace(/\s+/g, ' ').trim();
      p.parentNode.replaceChild(h3, p);
    });
  }

  /** El editor RTE a veces deja el título así: <div><h2>...</h2></div>. Promovemos el h2/h3 al padre. */
  function unwrapSoleHeadingWrappers(rte) {
    Array.from(rte.querySelectorAll('div')).forEach(function (div) {
      if (!div.parentNode) return;
      if (skipLegacyHeadingWrapper(div)) return;
      if (div.childElementCount !== 1) return;
      var only = div.firstElementChild;
      if (!only || (only.tagName !== 'H2' && only.tagName !== 'H3')) return;
      div.parentNode.insertBefore(only, div);
      div.parentNode.removeChild(div);
    });
  }

  function isVideoIframe(iframe) {
    var src = (iframe.getAttribute('src') || '').toLowerCase();
    return (
      src.indexOf('youtube.com') !== -1 ||
      src.indexOf('youtube-nocookie.com') !== -1 ||
      src.indexOf('player.vimeo.com') !== -1
    );
  }

  /**
   * Marca o envuelve iframes de YouTube/Vimeo cuando vienen solos en un <p>/<div> o sueltos en el panel:
   * así el CSS (.ecoway-rte-embed) les da ancho de columna y ratio 16:9 sin depender de :has() ni de nodos de texto.
   */
  function wrapVideoEmbeds(rte) {
    Array.from(rte.querySelectorAll('iframe')).forEach(function (iframe) {
      if (!isVideoIframe(iframe)) return;
      if (iframe.closest('.ecoway-rte-embed')) return;

      var parent = iframe.parentElement;
      if (!parent) return;

      if (parent.classList.contains('ecoway-accordion__panel')) {
        if (parent.children.length === 1 && parent.firstElementChild === iframe) {
          var wrap = document.createElement('div');
          wrap.className = 'ecoway-rte-embed';
          parent.insertBefore(wrap, iframe);
          wrap.appendChild(iframe);
        }
        return;
      }

      var tag = parent.tagName;
      if (tag !== 'P' && tag !== 'DIV') return;
      if (parent.closest('.card-item') || parent.closest('.card-grid')) return;
      if (parent.closest('figure')) return;
      if (parent.children.length !== 1 || parent.firstElementChild !== iframe) return;

      parent.classList.add('ecoway-rte-embed');
    });
  }

  /** Restaura h2/h3 planos si el DOM ya tenía acordeones (editor, recargas parciales). */
  function flattenAccordions(rte) {
    Array.from(rte.querySelectorAll('.ecoway-accordion')).forEach(function (wrapper) {
      var btn = wrapper.querySelector('.ecoway-accordion__trigger');
      var panel = wrapper.querySelector('.ecoway-accordion__panel');
      if (!btn || !panel || !wrapper.parentNode) return;

      var level = wrapper.getAttribute('data-ecoway-accordion-level') || '2';
      var titleEl = btn.querySelector('.ecoway-accordion__title');
      var heading = document.createElement('h' + level);
      if (titleEl && titleEl.innerHTML.trim()) {
        heading.innerHTML = titleEl.innerHTML;
      } else {
        heading.textContent = (btn.textContent || '').trim();
      }

      var parent = wrapper.parentNode;
      parent.insertBefore(heading, wrapper);
      while (panel.firstChild) {
        parent.insertBefore(panel.firstChild, wrapper);
      }
      parent.removeChild(wrapper);
    });
  }

  function looksAllCapsText(text) {
    var letters = text.replace(/[^a-zA-Z\u00C0-\u024F\u00D1\u00F1]/g, '');
    return letters.length >= 2 && letters === letters.toUpperCase();
  }

  function toSentenceCase(text) {
    var t = text.replace(/\s+/g, ' ').trim();
    if (!t) return t;
    return t.charAt(0).toUpperCase() + t.slice(1).toLowerCase();
  }

  /** h2/h3 en MAYÚSCULAS (Word / pegado) → mayúscula inicial y resto minúsculas. */
  function normalizeHeadingSentenceCase(rte) {
    Array.from(rte.querySelectorAll('h2, h3')).forEach(function (heading) {
      if (heading.closest('.card-grid') || heading.closest('a.card-item')) return;

      function walk(node) {
        if (node.nodeType === Node.TEXT_NODE) {
          var raw = node.textContent;
          if (!raw || !looksAllCapsText(raw)) return;
          node.textContent = toSentenceCase(raw);
        } else if (node.nodeType === Node.ELEMENT_NODE) {
          if (node.tagName === 'SCRIPT' || node.tagName === 'STYLE') return;
          Array.from(node.childNodes).forEach(walk);
        }
      }

      walk(heading);
    });
  }

  function init(root) {
    var rte = root.querySelector('.ecoway-single-article__rte');
    if (!rte) return;

    flattenAccordions(rte);
    normalizeNumberedPseudoHeadings(rte);
    unwrapSoleHeadingWrappers(rte);
    normalizeHeadingSentenceCase(rte);

    /* Siempre: vídeos fuera del bloque de acordeón o si el RTE ya venía con acordeones en el HTML. */
    if (rte.dataset.ecowayVideoEmbeds !== '1') {
      wrapVideoEmbeds(rte);
      rte.dataset.ecowayVideoEmbeds = '1';
    }

    if (rte.dataset.ecowayFeaturedDedupe !== '1') {
      hideLeadingFeaturedDuplicateRteImages(root);
      rte.dataset.ecowayFeaturedDedupe = '1';
    }
  }

  /** URL de imagen Shopify comparables (mismo archivo, distinto ?v= o _480x480 en el nombre). */
  function normalizeImageUrlForCompare(url) {
    if (!url || typeof url !== 'string') return '';
    return url
      .split('?')[0]
      .toLowerCase()
      .replace(/\d+[x]\d+/g, '');
  }

  function collapseBareWrapperIfOnlyMedia(rte, img) {
    var walk = img.parentElement;
    while (walk && walk !== rte) {
      var onlyTrivial = true;
      for (var c = walk.firstChild; c; c = c.nextSibling) {
        if (c.nodeType === 1 && c === img) continue;
        if (
          c.nodeType === 1 &&
          c.classList &&
          c.classList.contains('ecoway-rte-hide--duplicate-featured')
        ) {
          continue;
        }
        if (c.nodeType === 3 && !c.textContent.replace(/[\s\u00a0]/g, '')) continue;
        if (c.nodeType === 1 && c.tagName === 'BR') continue;
        if (
          c.nodeType === 1 &&
          c.tagName === 'SPAN' &&
          !c.textContent.replace(/[\s\u00a0]/g, '')
        ) {
          continue;
        }
        onlyTrivial = false;
        break;
      }
      if (!onlyTrivial) break;
      var next = walk.parentElement;
      walk.style.display = 'none';
      walk.setAttribute('data-ecoway-collapsed-duplicate', '1');
      walk = next;
    }
  }

  /**
   * Oculta en el RTE la primera tanda CONSECUTIVA de <img> que repite la imagen destacada (CDN / tamaños distintos).
   * Solo actúa si la primera repetición aparece antes que cualquier otro recurso visual distinto — evita quitar fotos válidas después.
   */
  function hideLeadingFeaturedDuplicateRteImages(articleEl) {
    if (!articleEl || !articleEl.classList.contains('ecoway-single-article')) return;
    if (!articleEl.classList.contains('ecoway-single-article--has-featured-image')) return;
    var featuredUrl = articleEl.getAttribute('data-ecoway-featured-src');
    var rte = articleEl.querySelector('.ecoway-single-article__rte');
    if (!featuredUrl || !rte) return;

    var target = normalizeImageUrlForCompare(featuredUrl);
    if (!target) return;

    var imgs = Array.from(rte.querySelectorAll('img')).filter(function (im) {
      if (im.closest('a.card-item') || im.closest('.card-grid')) return false;
      return true;
    });
    if (!imgs.length) return;

    var start = imgs.length;
    for (var s = 0; s < imgs.length; s++) {
      var ssrc = imgs[s].getAttribute('src') || '';
      if (!ssrc) continue;
      if (normalizeImageUrlForCompare(ssrc) === target) {
        start = s;
        break;
      }
    }
    if (start >= imgs.length) return;

    for (var i = start; i < imgs.length; i++) {
      var src = imgs[i].getAttribute('src') || '';
      if (normalizeImageUrlForCompare(src) !== target) break;
      imgs[i].classList.add('ecoway-rte-hide--duplicate-featured');
      imgs[i].setAttribute('aria-hidden', 'true');
      collapseBareWrapperIfOnlyMedia(rte, imgs[i]);
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.ecoway-single-article').forEach(init);
  });

  document.addEventListener('shopify:section:load', function (ev) {
    var section = ev.target;
    if (!section || !section.querySelector) return;
    var root = section.querySelector('.ecoway-single-article');
    if (root) init(root);
  });
})();
